import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject, combineLatest, filter, takeUntil } from 'rxjs';

import { List } from '@site-mate/dashpivot-shared-library';

import { RouteParamsService } from 'app/shared/service/route-params.service';

import { AddListModalComponent } from './add-list-modal.component';

@Component({
  selector: 'cc-add-list',
  template: '',
})
export class AddListComponent implements OnInit, OnDestroy {
  private readonly unsubscribe = new Subject<void>();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly modal: NgbModal,
    private readonly routeParamsService: RouteParamsService,
  ) {}

  ngOnInit() {
    const modalRef = this.setupModal();
    this.setupNavigateBack(modalRef);
    this.subscribeToParentPathUpdates(modalRef);
  }

  private setupModal() {
    const modalRef = this.modal.open(AddListModalComponent);
    modalRef.componentInstance.autoFocusInputOnOpen = true;

    return modalRef;
  }

  private setupNavigateBack(modalRef: NgbModalRef) {
    modalRef.result.then(this.navigateToNewList.bind(this)).catch(() => {
      this.navigateBack();
    });
  }

  private subscribeToParentPathUpdates(modalRef: NgbModalRef) {
    combineLatest([this.routeParamsService.get('company'), this.routeParamsService.get('project')])
      .pipe(
        filter(([company, project]) => Boolean(project || company)),
        takeUntil(this.unsubscribe),
      )
      .subscribe(([company, project]) => {
        const parentPath = project ? project.path : company.path;
        modalRef.componentInstance.parentPath = parentPath;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private navigateBack() {
    const options: NavigationExtras = {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    };

    void this.router.navigate(['..'], options);
  }

  private navigateToNewList(newList: List) {
    const options: NavigationExtras = {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    };

    void this.router.navigate(['..', String(newList._id)], options);
  }
}
